import { Component, OnInit, Inject, Optional, ViewChild } from '@angular/core';
import { contactFormConfig } from '../contact.component';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Contact } from 'src/shared/api';
import { PrimaryEmailAddressComponent } from '../../email-address/primary-email-address/primary-email-address.component';
import { PrimaryPhoneNumberComponent } from '../../phone-number/primary-phone-number/primary-phone-number.component';
import { FormConfig } from '../../form-cva.component';

@Component({
	selector: 'rpshared-contact-dialog',
	templateUrl: './contact-dialog.component.html',
	styleUrls: ['./contact-dialog.component.css'],
})
export class ContactDialogComponent extends SelfDestruct implements OnInit {
	form = this.fb.group(contactFormConfig) as FormGroup;
	@ViewChild(PrimaryEmailAddressComponent)
	primaryEmailComponent: PrimaryEmailAddressComponent;
	@ViewChild(PrimaryPhoneNumberComponent)
	primaryPhoneComponent: PrimaryPhoneNumberComponent;
	emailRequired = true;

	constructor(
		@Inject(MAT_DIALOG_DATA) @Optional() private readonly contact: Contact,
		private readonly fb: FormBuilder
	) {
		super();
	}

	ngOnInit() {
		const formConfig: FormConfig<Required<Contact>> = {...contactFormConfig};
			if(!this.emailRequired) {
				formConfig.emailAddresses = [[]];
			}
			this.form = this.fb.group(formConfig) as FormGroup;
		if (this.contact) {
			this.form.setValue(this.contact, { emitEvent: false });
		}
	}
	get getEmailControlInvalid() {
		if (this.primaryEmailComponent) {
			return this.primaryEmailComponent.form.invalid;
		}
		return true;
	}
	get getPhoneControlInvalid() {
		if (this.primaryPhoneComponent) {
			return this.primaryPhoneComponent.phoneNumberInput.invalid;
		}
		return true;
	}
}
